import type { ReactElement, SVGProps } from "react";
import { cn } from "@/lib/utils";

export function SkillsPageChevronIcon({
  expanded,
  ...props
}: SVGProps<SVGSVGElement> & { expanded?: boolean }): ReactElement {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      {...props}
      className={cn(
        "transition-transform duration-150",
        expanded && "rotate-90",
        props.className
      )}
    >
      <path
        d="M4.5 2.5L8 6L4.5 9.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
